import React, { SVGProps } from 'react';

export const ReplayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.0285 14.9166L14.633 12.5747H14.6886C14.8829 12.4517 15 12.2416 15 12.0162C15 11.7909 14.8829 11.5808 14.6886 11.4578L11.0841 9.11586C10.8713 8.97604 10.5965 8.96172 10.3696 9.07863C10.1426 9.19555 10.0005 9.42463 10 9.67432V14.3582C10.012 14.5906 10.1462 14.8007 10.3552 14.9142C10.5642 15.0277 10.8187 15.0286 11.0285 14.9166Z"
      fill="currentColor"
    />
  </svg>
);
